import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';

const features = [
  'Full Gym Access',
  'Group Classes',
  'Recovery Zone',
  'Personal Training Session',
  'Fitness Assessment',
  'Program Design',
  'Towel Service',
  'No Joining Fee',
  'No Lock-in Contract'
];

const memberships = [
  {
    name: 'GATEWAY',
    price: '44.50',
    features: [true, true, true, true, true, true, true, true, false]
  },
  {
    name: 'TRANSPORTER',
    price: '79.50',
    features: [true, true, true, true, true, true, true, true, false]
  },
  {
    name: 'ENTRY',
    price: '22.50',
    features: [true, false, false, true, false, false, false, false, false]
  },
  {
    name: 'RECOVERY',
    price: '25.00',
    features: [false, false, true, false, false, false, true, true, false]
  }
];

export default function ComparisonTable() {
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr>
            <th className="p-4 text-left">Features</th>
            {memberships.map((membership, index) => (
              <th key={index} className="p-4 text-center">
                <div className="text-xl font-bold">{membership.name}</div>
                <div className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                  ${membership.price}
                </div>
                <div className="text-sm text-gray-400">per week</div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {features.map((feature, index) => (
            <tr key={index} className="border-t border-white/10">
              <td className="p-4">{feature}</td>
              {memberships.map((membership, membershipIndex) => (
                <td key={membershipIndex} className="p-4 text-center">
                  {membership.features[index] ? (
                    <Check className="w-5 h-5 text-green-400 mx-auto" />
                  ) : (
                    <X className="w-5 h-5 text-red-400 mx-auto" />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}